/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './pages/**/*.{js,ts,jsx,tsx,mdx}',
    './components/**/*.{js,ts,jsx,tsx,mdx}',
    './app/**/*.{js,ts,jsx,tsx,mdx}',
  ],
  theme: {
    extend: {
      backgroundImage: {
        'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
        'gradient-conic':
          'conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))',
      },
      colors: {
        'maincolor': '#19459C',
        'maincolortrans': '#2331424d',
        // 'secondary': '#015B97',
        'secondary': '#163a7c',
        'third': '#DE1F2F',
        'forth': '#e3e3e3',
        'light': 'white',
        'mainhover': '#555555'

      },
      backgroundColor: ['hover'],
    },
  },
  plugins: [],
}
